// Components==============
import SearchBar from 'components/UI/SearchBar';
import React, { useContext } from 'react';
import { AgendaContext } from 'screens/Agenda';
import FromDate from '../FromDate';
import ToDate from '../ToDate';
import './index.module.scss';
import CheckBoxBar from '../CheckboxBar/CheckboxBar';
// =========================

export default function Filter() {
    const {
        searchValue,
        setSearchValue,
        selectedStartDate,
        setSelectedStartDate,
        selectedEndDate,
        setSelectedEndDate,
        networkChecked,
        setNetworkChecked,
    } = useContext(AgendaContext);

    return (
        <div styleName="grid">
            <div styleName="item">
                <SearchBar
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <CheckBoxBar
                    active={networkChecked}
                    onClick={() => setNetworkChecked((prev) => !prev)}
                >
                    Netwerkbijeenkomsten
                </CheckBoxBar>
                <h2 styleName="range ">Periode</h2>
                <FromDate
                    selectedStartDate={selectedStartDate}
                    setSelectedStartDate={setSelectedStartDate}
                />
                <ToDate
                    selectedEndDate={selectedEndDate}
                    setSelectedEndDate={setSelectedEndDate}
                />
            </div>
        </div>
    );
}
